import React from 'react'
import styled from '@emotion/styled'
import { FANCY_SCROLLBAR } from 'src/utils/styles'
import { ErrorBoundary } from 'src/components/errors/error-boundary'
import { printStyle, themeSpacing } from 'src/components/theme'
import { UnlockedLocation } from 'src/components/unlocked-location'
import { UserTier } from 'src/common-services'

// we want this page to scroll & have height of all contents
// when we are printing - otherwise print wont go below the fold
const print = printStyle`
  height: 100%;
  width: 100%;
  background: white;
  padding: 0 !important;
`

const InsightPageDiv = styled.div`
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  overflow-y: overlay;
  height: 100%;

  ${print}
  ${FANCY_SCROLLBAR}
  &>.main-page-content {
    padding: ${themeSpacing(6)}px;
    @media (max-width: 870px) {
      padding-inline: ${themeSpacing(6)}px;
    }
  }
`

const InsightFullPageDiv = styled.div`
  width: 100%;
  padding: ${themeSpacing(6)}px;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 870px) {
    padding-inline: ${themeSpacing(6)}px;
  }
`

type InsightPageProps = {
  children?: React.ReactNode
  tier?: UserTier
}

export const INSIGHT_PAGE_CLASS = 'insight-page'
export const InsightPage = (props: InsightPageProps) => {
  const { children, tier } = props

  return (
    <InsightPageDiv className={INSIGHT_PAGE_CLASS}>
      <UnlockedLocation tier={tier} />
      <div className="main-page-content">
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
    </InsightPageDiv>
  )
}

type InsightFullPageProps = {
  children?: React.ReactNode
}

export const InsightFullPage = (props: InsightFullPageProps) => {
  const { children } = props

  return (
    <InsightFullPageDiv className={INSIGHT_PAGE_CLASS}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </InsightFullPageDiv>
  )
}

export const InsightPageTwoColumns = styled.div`
  display: flex;

  & > div {
    flex: 1;
  }

  @media (max-width: 1500px) {
    flex-direction: column;

    & > div {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }

  & > div:nth-of-type(odd) {
    margin-right: 15px;
  }

  & > div:nth-of-type(even) {
    margin-left: 15px;
  }
`
